export default __webpack_public_path__ + "tasks-list.png";